<template lang="pug">
  .loader
    span.loader__animation
    p.loader__text {{this.text}}
</template>
<script>
export default {
  name: 'loader',
  props: ['text']
}
</script>

<style scoped lang="scss">
  @import "@/assets/style/_variables";

  .loader {
    color: #595959;
    font-family: $rubik-font-family;
    text-align: center;

    &__animation {
      animation: rotation 1s linear infinite;
      border: 5px solid #1A71B4;
      border-bottom-color: transparent;
      border-radius: 50%;
      box-sizing: border-box;
      display: inline-block;
      height: 48px;
      margin-bottom: 16px;
      width: 48px;
    }

    &__text {
      font-size: 20px;
    }
  }

  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
</style>
